import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';

import type { ProfileData } from '../_data/profiles';
import ProfileCard from './ProfileCard';

export interface ProfileListProps {
  readonly profileRows: ProfileData[][];
}

const ProfileList = ({ profileRows }: ProfileListProps) => {
  return (
    <LayoutGrid className="gap-y-8 md:gap-y-10 lg:gap-y-16">
      {profileRows.map((profileRow, rowIndex) => (
        <GridItem
          colStart={{ sm: 'main', lg: rowIndex % 2 === 0 ? 7 : 3 }}
          colEnd={{ sm: 'main', lg: rowIndex % 2 === 0 ? 23 : 19 }}
          key={`${profileRow.map((profile) => profile.id).join('_')}_row`}
        >
          <div
            className="grid gap-8 md:grid-cols-2 md:gap-6"
            data-cy="leadership_profile_list_row"
          >
            {profileRow.map((profile, profileIndex) => (
              <div key={profile.id}>
                <ProfileCard index={profileIndex} profile={profile} />
              </div>
            ))}
          </div>
        </GridItem>
      ))}
    </LayoutGrid>
  );
};

export default ProfileList;
